import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const traceabilityService = {
  // Fetch paginated traceability logs
  async getLogs(page, limit, token, search = {}) {
    const resp = await axios.get(`${API_URL}/api/traceability-logs`, {
      params: { page, limit, ...search },
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Search by ingredient name (partial match)
  async searchIngredientByName(name, token) {
    const resp = await axios.get(
      `${API_URL}/api/traceability-logs/ingredient-name`,
      {
        params: { name },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp;
  },

  // Search by ingredient lot code
  async searchIngredient(ingredientLotCode, token) {
    const resp = await axios.get(
      `${API_URL}/api/traceability-logs/ingredient-lot-code`,
      {
        params: { ingredientLotCode },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp;
  },

  // Fetch all products
  async getProducts(token) {
    const resp = await axios.get(`${API_URL}/api/products`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Fetch all customers (high limit to bypass pagination for client-side autocomplete)
  async getCustomers(token) {
    const resp = await axios.get(`${API_URL}/api/customers`, {
      params: { limit: 1000 },
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Create a new traceability record
  async createLog(payload, token) {
    const resp = await axios.post(
      `${API_URL}/api/traceability-logs`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp;
  },

  // Batch lot code full traceability lookup
  async searchBatchLotCode(lotCode, token) {
    const resp = await axios.get(`${API_URL}/api/traceability-logs/batch-lot-code`, {
      params: { lotCode },
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Search batch lot codes, optionally filtered by productId
  async searchBatchLotCodes(q, productId, token) {
    const params = { q };
    if (productId) params.productId = productId;
    const resp = await axios.get(`${API_URL}/api/batch/search`, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Get current inventory for a specific product + lot code
  async getLotInventory(productId, lotCode, token) {
    const resp = await axios.get(`${API_URL}/api/inventory/lot`, {
      params: { productId, lotCode },
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp;
  },

  // Update an existing traceability record
  async updateLog(id, payload, token) {
    const resp = await axios.put(
      `${API_URL}/api/traceability-logs/${id}`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp;
  },
};

export default traceabilityService;